export default "__VITE_ASSET__B$zeLhpF__"